export default "__VITE_ASSET__2yuSwgF6__"